export default "__VITE_ASSET__kJPZM134__"